import React from 'react';
import { Avatar } from '@amzn/awsui-chat-components-console';
import { ChatBubbleAvatarProps } from './types';

const ChatBubbleAvatar: React.FC<ChatBubbleAvatarProps> = ({ 
    type, 
    name = 'Assistant', 
    initials = 'AI',
    loading 
}) => {
    if (type === 'assistant') {
        return <Avatar color="gen-ai" iconName="gen-ai" tooltipText={name} ariaLabel={name} loading={loading} />;
    }
    return <Avatar initials={initials} tooltipText={name} ariaLabel={name} />;
};

export default ChatBubbleAvatar;
